module.exports = __webpack_public_path__ + "img/Burundi.6815a5bc.svg";